export enum MockBehavior { Loose, Strict }